<template>
  <div style="height: 100vh;" class="mt-10">You are successfully login to GHM DataPortal.</div>
</template>
<script>
export default {};
</script>
<style scoped>
</style>
